import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class ButtonTextSetting {
  public viewObj: Element;
  public callBackFunc: Function;
  public x: number;
  public y: number;
  public rotation: number = 0;
  public transformMatrix: string;
  public targetItem: marietta.webcad.item.MonicaObject;
  public spt: SVGSprite;

  /**
   * コンストラクタ
   * */
  constructor(container: Element, target: marietta.webcad.item.MonicaObject) {
    this.viewObj = document.querySelector('#lib_icon_setting svg > g').cloneNode(true) as HTMLElement;
    this.viewObj.setAttribute('id', 'icon_setting');
    container.appendChild(this.viewObj);

    // アクション
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      this.viewObj.addEventListener('touchend', this.onMouseUpMe, { passive: false });
    } else {
      this.viewObj.addEventListener('mouseup', this.onMouseUpMe);
    }

    this.targetItem = target;
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  private onMouseUpMe = (e: MouseEvent) => {
    // 選択モードのときは、バブリングさせない
    e.stopPropagation();
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.targetItem;
    // pinかfreeTextかの判定
    const isPin = marietta.webcad.WebCADGlobal.isPinTextItem(this.targetItem.itemInfo.id);
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.FreeCharacterInputDialog, false, false, false, false, { isPinText: isPin });
  }

  /**
   * 移動 XY
   */
  public move(x: number, y: number) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 移動X
   */
  public moveX(x: number) {
    this.x = x;
    this.updateTranslate();
  }

  /**
   * 移動Y
   */
  public moveY(y: number) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * Translateのアップデート
   */
  public updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1.5 / root.scaleX;

    // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
    this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x + 35 - 35 * sc},${this.y})`;

    // this.transformMatrix = "matrix(1,0,0,1," + this.x + "," + this.y + ")";
    this.viewObj.setAttribute('transform', this.transformMatrix);
  }

  /**
   * アイコンの非表示
   */
  public hide() {
    (<HTMLElement>this.viewObj).style.visibility = 'hidden';
  }

  /**
   * アイコンの表示
   */
  public show() {
    (<HTMLElement>this.viewObj).style.visibility = 'visible';
  }
}
